import React, { useEffect, useState, useContext } from 'react';
import jsVectorMap from 'jsvectormap';
import 'jsvectormap/dist/maps/world.js';
import 'jsvectormap/dist/jsvectormap.min.css';
import { Card, CardHeader, CardHeaderBtn, CardBody } from '../../components/card/card.jsx';
import Chart from 'react-apexcharts';
import ChartJS from 'chart.js/auto';
import { Icon } from '@iconify/react';
import Moment from 'moment';
import { getChartJsDefaultOptions } from './../../composables/chartOptions.js';
import { externalAddress, AppSettings, botspotAddress } from '../../config/app-settings.js';
import { useParams, Link, useNavigate, useLocation } from 'react-router-dom';

function Backtest() {

	const context = useContext(AppSettings);
	const navigate = useNavigate();
	const location = useLocation();

	const [chartOptions, setChartOptions] = useState();

	const { id } = useParams()

	const [estrategia, setEstrategia] = useState([]);
	const [metricas, setMetricas] = useState([]);
	const [equityChart, setEquityChart] = useState([]);
	const [barChart, setBarChart] = useState([]);
	const [seriesChart, setSeriesChart] = useState([]);
	const [data, setData] = useState([]);
	const [totalMeses, setTotalMeses] = useState('');
	const [botspotScore, setBotspotScore] = useState('');
	
	
	function getChartOptions() {
		var themeRgb = (getComputedStyle(document.body).getPropertyValue('--bs-theme-rgb')).trim();
		
		return {
			chart: { sparkline: { enabled: true } },
			colors: ['rgba('+ themeRgb + ', .95)', 'rgba('+ themeRgb + ', .35)',],
			stroke: { show: false },
			tooltip: { y: { title: { formatter: function (seriesName) { return ''; } } } }
		};
	}
  
	function renderMap() {
			var theme = (getComputedStyle(document.body).getPropertyValue('--bs-theme')).trim();
			var white = (getComputedStyle(document.body).getPropertyValue('--bs-white')).trim();
			var whiteRgb = (getComputedStyle(document.body).getPropertyValue('--bs-white-rgb')).trim();
			var bodyFontFamily = (getComputedStyle(document.body).getPropertyValue('--bs-body-font-family')).trim();
			const elm = document.getElementById('map-container');
			const mapElm = document.querySelectorAll('.jvm-tooltip');
			
			if (mapElm) {
				for (let i = 0; i < mapElm.length; i++) {
					mapElm[i].remove();
				}
			}
			if (elm) {
				elm.innerHTML = '<div id="map"></div>';
				new jsVectorMap({
					selector: '#map',
					map: 'world',
					zoomButtons: true,
					normalizeFunction: 'polynomial',
					hoverOpacity: 0.5,
					hoverColor: false,
					zoomOnScroll: false,
					series: { regions: [{ normalizeFunction: 'polynomial' }] },
					labels: { markers: { render: (marker) => marker.name } },
					focusOn: { x: 0.5, y: 0.5, scale: 1 },
					markers: [
						{ name: "Egypt", coords: [26.8206, 30.8025] },
						{ name: "Russia", coords: [61.524, 105.3188] },
						{ name: "Canada", coords: [56.1304, -106.3468] },
						{ name: "Greenland", coords: [71.7069, -42.6043] },
						{ name: "Brazil", coords: [-14.235, -51.9253] }
					],
					markerStyle: { initial: { fill: theme, stroke: 'none', r: 5 }, hover: { fill: theme } },
					markerLabelStyle: { initial: { fontFamily: bodyFontFamily, fontSize: '10px', fill: 'rgba('+ whiteRgb + ', .75)' } },
					regionStyle: { initial: { fill: white, fillOpacity: 0.35, stroke: 'none', strokeWidth: 0.4, strokeOpacity: 1 }, hover: { fillOpacity: 0.5 } },
					backgroundColor: 'transparent',
				});
			}
	}

	function renderChart(lineChart, yearsChart, dailyLineChart) {
		function newDate(days) {
			return Moment().add(days, 'd').format('D MMM');
		}

		function formatarData(dataMMDDYYYY) {
			const [mes, dia, ano] = dataMMDDYYYY.split("-");
			return `${dia}/${mes}/${ano}`;
		}
		
		// color & font variable
		var gray300Color = (getComputedStyle(document.body).getPropertyValue('--bs-gray-300')).trim();
		var gray300RgbColor = (getComputedStyle(document.body).getPropertyValue('--bs-gray-300-rgb')).trim();
		var indigoColor = (getComputedStyle(document.body).getPropertyValue('--bs-indigo')).trim();
		var bodyBg = (getComputedStyle(document.body).getPropertyValue('--bs-body-bg')).trim();
		var themeColor = (getComputedStyle(document.body).getPropertyValue('--bs-theme')).trim();
	

		var color1 = 'rgba(40, 120, 212, 0.3)';
		// #chart3
		var chart3 = '';
		var chart3Container = document.getElementById('chart-3');
		if (chart3) {
			chart3.destroy();
		}
		if (chart3Container) {

			//console.log('lineChart')
			//console.log(lineChart)

			const values = lineChart.map(item => item.y);
			const labels = lineChart.map(item => formatarData(item.x));

			//console.log(values.length)
			//console.log(labels.length)

			chart3Container.innerHTML = '<canvas id="chart3" className="w-100" height="390"></canvas>';
			chart3 = new ChartJS(document.getElementById('chart3').getContext('2d'), {
				type: 'line',
				data: {
					labels: labels,
					datasets: [{
						color: indigoColor,
						backgroundColor: color1,
						borderColor: themeColor,
						borderWidth: 1,
						pointBackgroundColor: bodyBg,
						pointBorderWidth: 2,
						pointRadius: 3,
						pointHoverBackgroundColor: bodyBg,
						pointHoverBorderColor: themeColor,
						pointHoverRadius: 6,
						pointHoverBorderWidth: 2,
						fill: true,
						data: values
					},
					/*
					{
						color: themeColor,
						backgroundColor: 'rgba(226, 14, 43, 0.3)',
						borderColor: 'rgba(226, 14, 43, 0.8)',
						borderWidth: 1,
						pointBackgroundColor: bodyBg,
						pointBorderWidth: 2,
						pointRadius: 3,
						pointHoverBackgroundColor: bodyBg,
						pointHoverBorderColor: themeColor,
						pointHoverRadius: 6,
						pointHoverBorderWidth: 2,
						fill: true,
						data: [0, 0, 0, 0, -9, -16, -18, 0, 0, 0, -15,-10,0,0,0,0,-15,-35,0]
					}*/]
				},
				options: {
					maintainAspectRatio: false,
					/*
					scales: {
						x: {
							grid: {
							display: false // ⛔ remove grid vertical
							}
						},
						y: {
							grid: {
							display: false // ⛔ remove grid horizontal
							}
						}
					}
						*/
				}
			});
		}

		var chart4 = '';
		var chart4Container = document.getElementById('chart-4');
		if (chart4) {
			chart4.destroy();
		}
		if (chart4Container) {

			const barValues = yearsChart.data;
			const barLabels = yearsChart.anos;

			chart4Container.innerHTML = '<canvas id="chart4" className="w-100" height="390"></canvas>';
			chart4 = new ChartJS(document.getElementById('chart4').getContext('2d'), {
				type: 'bar',
				data: {
					labels: barLabels,
					datasets: [{
					label: 'Retorno Anual',
					data: barValues,
					backgroundColor: themeColor,
					borderColor: themeColor,
					borderWidth: 1.5
					}]
				},
				options: {
					maintainAspectRatio: false
				}
			});
		}

		var color2 = 'rgba(40, 120, 212, 0.8)';
		var chart5 = '';
		var chart5Container = document.getElementById('chart-5');
		if (chart5) {
			chart5.destroy();
		}

		//const DATA_COUNT = 7;
		//const NUMBER_CFG = {count: DATA_COUNT, min: -100, max: 100};

		const dailyData = dailyLineChart.map(item => item.y);
		const labels = dailyLineChart.map(item => formatarData(item.x));

		//const labels = [-37.72, 36.44, 41.91, 15.79, 24.92, -8.85, 0.69, 24.44, -15.21, -52.09, -33.05, 28.25, 30.67, -33.74, 42.25, -18.04, 8.09, -26.41, -46.51, 36.1, 12.43, 65.87, 17.47, -5.27, 11.35, -17.55, 6.75, -14.62, 44.71, -64.56, -38.88, -23.79, -27.13, 35.11, 4.94, 15.17, -30.61, -45.09, 39.6, -22.49, 26.97, 20.44, -14.5, -36.45, 57.74, -21.99, 39.07, -19.26, 1.47, -62.09, -18.25, -2.65, -25.87, -50.5, 16.73, -0.41, -21.77, -20.79, -63.07, 13.86, 16.36, 15.63, -32.4, 27.0, -41.53, -26.86, 34.49, -19.94, 19.78, -2.3, -22.31, 33.49, 9.14, 3.37, 21.1, -59.93, 49.26, 3.31, 25.84, -25.79, 12.73, 19.49, -25.67, 1.06, -14.93, -24.91, -56.58, -63.87, -10.79, 2.06, -16.21, 2.58, 21.85, 23.51, 11.55, -2.8, -10.68, 15.36, 27.63, 22.8, 0.7, 47.42, -8.45, -11.12, 10.49, 28.28, -35.65, 7.34, -0.05, -4.62, -49.9, 14.13, 0.59, -16.12, 6.36, -32.44, 6.68, -0.33, 10.09, 8.85, -21.17, 87.69, -26.5, 6.28, -7.13, -22.31, -10.55, 23.09, -11.93, 24.79, 29.61, 21.0, 35.14, 10.76, 17.23, 10.53, 5.55, 15.8, -45.43, -5.73, 68.09, 27.48, 14.67, 68.56, -2.1, 18.2, 32.79, 23.64, -13.53, -23.92, 47.27, 71.07, 1.29, 12.41, 32.2, 22.45, -22.31, -60.33, 0.73, -39.1, -7.43, 0.84, -53.19, -29.18, 4.29, -8.72, -22.98, 18.78, -5.9, -78.79, 22.3, -47.15, 11.85, 5.19, -0.43, 36.3, 14.66, -8.55, -0.5, -5.94, -71.25, 8.78, 14.79, -48.99, -42.41, 26.31, -19.76, -7.52, -0.1, 14.08, 20.5, 62.08, -23.3, 21.82, 21.78, 28.09, 7.8, 47.3, 16.01, 16.47, -1.85, -69.21, -7.97, 38.47, 10.25, 29.28, 13.74, -52.25, -10.96, -43.09, -3.9, 18.12, 1.59, -22.55, 16.11, -0.58, -17.27, -12.54, -17.05, 3.6, 40.96, 8.46, -28.94, -23.44, -78.65, 5.94, 6.98, 11.0, -19.8, 8.69, 28.32, 32.15, 8.13, -28.87, 3.52, -13.57, -6.95, 32.48, -36.73, -17.3, -19.72, 58.18, -28.13, -42.37, -8.52, -0.14, 18.35, -17.51, -40.98, 15.36, 12.21, 7.89, 37.86, -32.44, 23.77, 38.96, 24.89, 12.09, -35.61, 25.32, 14.95, -41.23, -16.72, 9.33, -15.43, -23.71, 44.32, 11.3, -1.56, -13.2, 33.33, 2.57, 7.93, 45.38, 7.77, -16.4, 4.09, 6.3, -3.22, 9.02, 6.27, 9.8, -43.4, 4.9, 22.21, 23.21, 12.66, -41.97, -26.01, -12.53, -47.72, 29.52, -10.4, -26.2, 12.31, -36.48, 50.03, 9.01, 89.93, 7.84, 15.93, -23.52, 30.02, 13.25, 26.38, 13.09, -24.87, 22.3, -23.84, -7.98, 11.07, 0.58, -31.91, 38.94, -2.15, 54.61, -29.15, -34.69, -2.33, -8.08, -27.36, -5.9, 15.31, -22.64, -11.03, -22.29, -19.83, 26.28, -13.98, 26.66, -4.95, 8.53, -1.93, -24.17, 6.99, 7.38, -34.59, 5.85, 69.21, -48.58, -26.74, 41.44, 50.72, 2.88, -40.01, 6.73, 11.21, 6.25, 8.46, 37.82, -28.74, -49.73, -43.01, -14.52, -60.49, 17.07, 48.27, 21.03, -5.12, -49.04, -21.35, 32.72, 65.86, 21.85, 13.18, -36.02, 12.66, -14.22, 0.35, -6.51, -36.64, 15.85, 23.29, 49.72, 11.34, 3.11, -17.54, -8.61, -22.87, -19.43, -47.14, -18.36, -8.85, 3.52, -5.91, -34.83, -12.95, 6.96, 0.18, -18.19, 8.22, -26.44, -19.69, 58.25, -45.15, 42.65, -56.53, 3.34, -16.54, 19.22, 18.09, 23.9, 16.56, 18.78, -17.48, 0.77, 21.7, -23.64, -4.04, -13.89, -22.32, -16.72, -32.83, 0.09, -9.66, 20.7, -47.63, -57.72, 0.35, -14.5, 6.17, -24.61, 10.75, -12.48, -31.31, 27.61, -3.85, 22.28, 4.58, 36.07, -82.3, 70.96, 36.77, 35.17, 56.09, -6.44, 27.78, 11.68, 4.24, -52.02, 10.29, -5.6, -27.45, 25.36, -27.93, -26.09, 20.37, -35.48, -9.33, -3.07, -25.41, 48.74, -6.73, 15.69, -19.61, 9.72, -4.45, -5.23, -10.95, 23.82, -16.65, 29.41, 20.06, 24.96, 4.4, -1.47, -1.71, 16.27, 0.77, -0.69, 61.33, 3.11, 12.46, -1.05, 29.66, 20.95, -3.83, -23.4, 57.41, -65.22, 63.43, -26.72, 7.82, -8.45, 16.04, 11.92, -44.75, 55.66, 63.56, 3.26, -40.56, 0.45, 16.99, 48.41, -21.51, -24.28, -4.3, -56.84, -11.39, 9.51, -14.62, 49.96, -43.34, -8.59, 20.91, 57.32, 3.67, -42.87, -43.62, 34.85, 8.34, -3.54, -39.82, -7.34, 23.38, -16.34, -6.73, -21.87, 19.61, 11.55, 15.91, -48.93, 31.86, -8.75, 46.49, -5.04, 2.24, -6.18, -21.21, 49.18, -54.3, -34.72, 44.72, 13.58, -12.75, 36.43, 29.56, 6.78, -70.78, 44.47, 26.86, 17.68, -2.05, -7.67, -29.99, 27.73, 26.68, -20.88, 12.86, -62.41, 23.44, 62.62, 27.33, 9.12, -16.36, -1.66, 52.32, -32.5, 19.53, -32.0, 18.27, 23.48, 20.58, 20.05, 26.83, -22.13, -15.65, -22.41, -49.49, 12.65, -38.32, -22.71, -1.63, 32.26, -1.67, -2.8, 40.29, 0.89, -4.96, -7.99, 3.0, 20.2, 15.93, -35.72, -7.25, -9.19, -13.33, -5.19, -3.7, -44.57, -34.7, 7.94, -24.55, -28.5, 18.73, -16.98, 42.03, 15.57, -27.86, -35.67, 2.32, 16.27, -11.98, -6.84, 33.88, -74.53, 11.31, -2.14, 18.06, 13.8, 22.36, -49.13, -53.2, -0.76, 2.37, 38.2, 14.43, -0.52, -35.23, 29.99, -28.8, -17.6, 39.26, 3.11, 8.42, 3.6, -3.78, 36.97, 17.4, 21.19, 65.18, 34.14, -3.76, 13.88, -21.05, -26.83, 12.49, 25.01, 29.79, 9.57, -7.19, -39.02, 40.2, -37.59, 16.51, 0.26, 1.5, -17.31, 10.86, -42.04, -1.37, -45.82, -33.57, -63.95, 30.73, 14.7, -14.9, 17.84, 7.75, 18.16, -20.05, -8.21, 6.13, 21.23, 27.56, -28.25, -30.36, 11.0, 66.84, -14.88, 9.16, -43.53, 4.4, 49.71, 29.39, -11.07, 13.8, 11.53, -24.85, 12.83, 15.05, 41.62, -44.83, -9.97, 14.15, -36.99, 10.71, -4.1, -42.0, -7.7, 3.32, 22.93, 5.91, 7.12, 5.57, -33.11, -24.81, 26.52, 31.27, -18.34, -11.11, 3.73, 47.62, -11.93, 1.37, 6.25, 10.25, -7.78, -23.85, -4.08, 58.23, 7.45, 4.21, 29.36, 60.55, -39.44, 14.07, 27.23, 30.32, -12.97, 1.45, 15.89, 15.77, -30.87, -9.49, -26.19, -8.24, 4.28, 4.92, -2.91, -32.19, 20.29, -9.13, 3.27, -31.37, 34.51, 31.42, -13.88, 1.9, -35.31, 2.64, -11.2, -100.0, 5.04, 57.7, -43.23, 0.38, 15.92, -62.88, 0.95, 22.9, 0.07, -8.79, -22.09, 4.81, -12.19, 8.36, 13.39, -2.9, -18.72, 4.07, -35.12, -5.41, 6.26, -3.76, -47.54, -43.32, 51.35, 23.38, -12.92, -5.14, 16.3, -21.77, 37.86, 26.23, 29.91, -10.21, -27.32, 10.31, -12.49, 25.01, -9.89, -15.21, 21.51, -37.32, -62.14, 13.34, 26.2, 36.22, -31.22, 2.77, -16.31, -20.86, -11.86, -24.61, -3.71, 6.67, 31.44, 42.61, -18.29, -11.67, 37.0, 52.79, 63.2, 14.28, -7.11, -8.7, -0.2, -35.43, 12.46, -33.33, -7.54, -21.87, -53.3, -44.05, -30.48, 9.32, -13.28, 18.46, -47.19, 42.46, 4.82, 0.9, -49.4, -9.89, -7.59, -17.77, 1.09, -25.92, -21.08, 5.93, -29.59, 42.77, 47.69, 3.27, -35.86, 18.44, 0.24, -53.14, 14.02, 37.11, 75.39, 14.06, 14.72, -26.91, -46.01, -20.08, -25.37, -41.81, 13.29, -27.25, -9.8, 3.26, -18.63, -28.17, 24.04, -20.79, 53.77, 26.79, 19.72, 46.97, -5.78, 8.72, 0.09, -18.2, -11.14, 8.44, -25.65, -35.05, -12.89, -24.64, -17.57, 19.34, -9.88, -1.79, 6.2, 30.77, 39.21, -60.25, -13.8, 20.15, 20.31, 0.94, -10.13, 2.2, 11.58, 9.48, 19.6, 4.4, 50.93, 6.88, 59.97, -11.01, 18.78, 10.76, 7.51, 4.42, -2.78, -1.1, 2.25, 0.14, -38.51, -21.53, 12.0, -38.42, -1.21, -8.96, -10.33, 29.88, 32.8, 18.7, 9.91, 8.8, -76.96, -10.98, 44.35, 6.17, -21.52, -37.67, 3.91, 17.39, -16.52, -20.21, 21.48, -17.01, 18.63, 66.55, -16.45, -5.21, -14.2, 26.21, -60.21, -25.78, 8.28, -31.86, -49.48, 37.94, -17.53, -79.12, -40.61, 37.5, -25.76, 28.78, 3.0, 19.43, -53.79, -2.66, 11.27, -13.81, 23.84, 18.75, 13.23, -4.54, 25.6, -21.11, -4.43, -61.45, -22.03, -17.31, -15.78, -45.46, -4.09, 21.53, 62.81, 21.21, -29.33, 26.73, 32.09, 19.88, 25.17, -28.27, 19.52, 13.4, -11.62, 3.2, -24.63, 2.06, -25.52, -65.66, 36.88, -1.34, -23.04, 32.09, 3.99, -22.01, 33.36, -32.58, -48.51, -7.61, 35.65, 4.58, -16.8, -25.17, 14.6, -7.81, 8.52, -25.75, -5.74, 26.16, 29.35, -28.7, 24.21, 74.54, -9.09, 47.52, -47.08, -39.26, 43.73, -26.08, 63.97, -55.2, 36.36, -17.2, -35.73, 34.08, 5.0, 7.21, 14.46, 66.79, 40.7, 39.51, -12.39, -2.97, 39.69, -54.79, 6.69, 0.43, 22.33, -32.25, 19.17, 20.94, -56.29, -8.0, -32.23, 48.72, -5.14, -63.13, -17.92, -29.48, 2.99, -52.16, 56.63, -15.59, 36.49, -20.45, -16.88, 36.7, -47.15, -11.43, -7.81, 27.77, -11.54, 65.26, 9.63, 17.83, -20.24, 9.86, 0.83, -14.57, -12.72, -23.3, -10.01, -22.02, -22.17, 0.06, -29.66, -18.72, 21.34, 22.63, 47.07, 32.8, -32.61, 16.15, -58.07, 35.26, 10.69, 11.37, -49.52, -23.01, 2.81, 28.88, -19.96, 19.7, -12.03, -18.11, -15.57, 4.98, -21.07, -3.64, -36.39, -55.73, 57.56, -44.29, -15.05, -39.22, 14.13, -54.04, 17.36, -24.99, 33.42, -7.23, -23.78, 36.3, 57.38, 3.3, -4.19, 23.53, -52.48, -26.57, -1.45, -11.61, 0.25, -8.61, 23.88, -23.36, 39.1, 19.17, -19.74, -10.94, 23.92, -4.07, 29.3, 23.18, -35.66, 18.46, -39.54, -25.34, -21.28, -10.73, 17.44, 18.32, -23.87, 3.27, -0.6, -40.66, -0.38, -13.42, -10.6, -13.43, -8.23, -17.18, 13.75, -35.63, 18.15, 19.24, -25.57, -20.77, 1.41, -26.38, -13.26, -12.13, 54.72, -9.09, 7.58, 38.94, 12.76, 57.78, 7.42, 40.66, 1.78, -15.05, 39.26, 20.39, 17.29, -8.93, -35.18, -13.82, 13.86, -30.12, 23.08, -23.03, 70.38, 100.0, -21.25, 2.08, 26.94, 23.3, 49.5, 34.56, 1.04, 7.7, 10.93, -36.01, 41.92, 17.64, -40.38, 2.12, -4.27, 14.28, 29.26, -10.22, 4.17, 9.99, 26.97, 6.65, -65.58, 89.68, 33.73, 7.65, 17.03, -45.83, 28.74, 33.4, 24.5, 42.57, 5.01, -49.21, -8.03, -13.46, -14.95, -3.17, -22.05, -34.83, -32.79, 22.93, -2.96, -4.49, -6.71, -37.4, 20.2, 7.29, -9.43, -1.53, 17.09, -32.36, -22.61, -40.32, -36.19, 10.2, 0.56, -34.63, 4.96, -16.12, 29.56, 75.58, -36.45, 6.38, -4.76, -26.64, -33.0, 14.45, -2.89, 3.75, 11.27, 6.99, -55.78, -31.65, -31.67, -24.33, -67.78, 7.39, 28.24, -41.15, 11.89, -39.43, 41.48, 20.92, -44.26, -0.83, 5.09, 6.52, 26.8, 2.32, -22.25, -29.62, -21.96, 16.22, 21.46, -21.02, -11.34, -3.51, -24.92, -19.5, 38.19, 1.65, -47.21, 14.63, -5.64, 35.3, 33.18, -42.26, -66.83, 7.26, 17.65, -32.9, -10.46, -20.12, -83.84, -21.89, 28.2, -7.52, -55.84, 34.3, 30.95, 58.41, -13.97, -0.24, -7.14, 12.05, -20.39, -9.03, 8.09, 24.75, -6.41, 6.07, -7.17, 36.28, 33.6, -13.83, 40.31, 3.21, -39.52, 18.19, -20.85, -16.65, 28.55, -5.03, 38.6, 34.58, 10.59, -17.81, 55.68, 54.18, 18.82, 51.76, -31.86, -15.26, 54.08, 16.86, 34.08, -3.62, 29.48, -17.36, -41.21, -33.21, 80.47, 13.64, -21.98, -36.72, 11.72, -10.68, 2.79, -13.98, -35.93, -44.56, -2.31, 41.57, -19.15, -77.42, 73.67, 9.81, 4.97, -44.14, 30.56, 7.66, -23.15, 7.37, -11.37, 14.58, -11.7, -31.54, -38.13, -25.83, -30.76, -16.96, -27.29, -50.67, 5.76, 16.91, -20.88, -21.55, -3.24, -15.8, 34.49, -27.69, 46.61, -0.92, 12.08, -19.29, -1.83, 24.66, -7.48, 46.79, 24.61, -14.73, 49.3, -6.68, 7.58, 13.06, 37.62, -15.54, -45.87, -6.45, -9.59, -10.86, -78.44, -12.58, 10.15, 14.93, -24.52, 3.24, 4.56, -3.15, -47.31, 6.92, -4.45, -4.18, 27.98, -14.32, -10.05, -17.57, -11.36, -48.56, 26.96, 35.07, 42.41, -6.23, -36.89, 3.7, -30.43, 6.73, 17.99, -43.7, 33.34, 16.45, -32.84, 17.0, 6.43, 57.56, -18.89, -12.75, 19.27, -3.85, -8.39, 22.91, 36.94, -7.78, -59.94, -27.81, 10.54];
		console.log('labels')
		console.log(labels.length)
		const data = {
		labels: labels,
		datasets: [
			{
			label: 'Retorno Diário',
			//data: [-37.72, 36.44, 41.91, 15.79, 24.92, -8.85, 0.69, 24.44, -15.21, -52.09, -33.05, 28.25, 30.67, -33.74, 42.25, -18.04, 8.09, -26.41, -46.51, 36.1, 12.43, 65.87, 17.47, -5.27, 11.35, -17.55, 6.75, -14.62, 44.71, -64.56, -38.88, -23.79, -27.13, 35.11, 4.94, 15.17, -30.61, -45.09, 39.6, -22.49, 26.97, 20.44, -14.5, -36.45, 57.74, -21.99, 39.07, -19.26, 1.47, -62.09, -18.25, -2.65, -25.87, -50.5, 16.73, -0.41, -21.77, -20.79, -63.07, 13.86, 16.36, 15.63, -32.4, 27.0, -41.53, -26.86, 34.49, -19.94, 19.78, -2.3, -22.31, 33.49, 9.14, 3.37, 21.1, -59.93, 49.26, 3.31, 25.84, -25.79, 12.73, 19.49, -25.67, 1.06, -14.93, -24.91, -56.58, -63.87, -10.79, 2.06, -16.21, 2.58, 21.85, 23.51, 11.55, -2.8, -10.68, 15.36, 27.63, 22.8, 0.7, 47.42, -8.45, -11.12, 10.49, 28.28, -35.65, 7.34, -0.05, -4.62, -49.9, 14.13, 0.59, -16.12, 6.36, -32.44, 6.68, -0.33, 10.09, 8.85, -21.17, 87.69, -26.5, 6.28, -7.13, -22.31, -10.55, 23.09, -11.93, 24.79, 29.61, 21.0, 35.14, 10.76, 17.23, 10.53, 5.55, 15.8, -45.43, -5.73, 68.09, 27.48, 14.67, 68.56, -2.1, 18.2, 32.79, 23.64, -13.53, -23.92, 47.27, 71.07, 1.29, 12.41, 32.2, 22.45, -22.31, -60.33, 0.73, -39.1, -7.43, 0.84, -53.19, -29.18, 4.29, -8.72, -22.98, 18.78, -5.9, -78.79, 22.3, -47.15, 11.85, 5.19, -0.43, 36.3, 14.66, -8.55, -0.5, -5.94, -71.25, 8.78, 14.79, -48.99, -42.41, 26.31, -19.76, -7.52, -0.1, 14.08, 20.5, 62.08, -23.3, 21.82, 21.78, 28.09, 7.8, 47.3, 16.01, 16.47, -1.85, -69.21, -7.97, 38.47, 10.25, 29.28, 13.74, -52.25, -10.96, -43.09, -3.9, 18.12, 1.59, -22.55, 16.11, -0.58, -17.27, -12.54, -17.05, 3.6, 40.96, 8.46, -28.94, -23.44, -78.65, 5.94, 6.98, 11.0, -19.8, 8.69, 28.32, 32.15, 8.13, -28.87, 3.52, -13.57, -6.95, 32.48, -36.73, -17.3, -19.72, 58.18, -28.13, -42.37, -8.52, -0.14, 18.35, -17.51, -40.98, 15.36, 12.21, 7.89, 37.86, -32.44, 23.77, 38.96, 24.89, 12.09, -35.61, 25.32, 14.95, -41.23, -16.72, 9.33, -15.43, -23.71, 44.32, 11.3, -1.56, -13.2, 33.33, 2.57, 7.93, 45.38, 7.77, -16.4, 4.09, 6.3, -3.22, 9.02, 6.27, 9.8, -43.4, 4.9, 22.21, 23.21, 12.66, -41.97, -26.01, -12.53, -47.72, 29.52, -10.4, -26.2, 12.31, -36.48, 50.03, 9.01, 89.93, 7.84, 15.93, -23.52, 30.02, 13.25, 26.38, 13.09, -24.87, 22.3, -23.84, -7.98, 11.07, 0.58, -31.91, 38.94, -2.15, 54.61, -29.15, -34.69, -2.33, -8.08, -27.36, -5.9, 15.31, -22.64, -11.03, -22.29, -19.83, 26.28, -13.98, 26.66, -4.95, 8.53, -1.93, -24.17, 6.99, 7.38, -34.59, 5.85, 69.21, -48.58, -26.74, 41.44, 50.72, 2.88, -40.01, 6.73, 11.21, 6.25, 8.46, 37.82, -28.74, -49.73, -43.01, -14.52, -60.49, 17.07, 48.27, 21.03, -5.12, -49.04, -21.35, 32.72, 65.86, 21.85, 13.18, -36.02, 12.66, -14.22, 0.35, -6.51, -36.64, 15.85, 23.29, 49.72, 11.34, 3.11, -17.54, -8.61, -22.87, -19.43, -47.14, -18.36, -8.85, 3.52, -5.91, -34.83, -12.95, 6.96, 0.18, -18.19, 8.22, -26.44, -19.69, 58.25, -45.15, 42.65, -56.53, 3.34, -16.54, 19.22, 18.09, 23.9, 16.56, 18.78, -17.48, 0.77, 21.7, -23.64, -4.04, -13.89, -22.32, -16.72, -32.83, 0.09, -9.66, 20.7, -47.63, -57.72, 0.35, -14.5, 6.17, -24.61, 10.75, -12.48, -31.31, 27.61, -3.85, 22.28, 4.58, 36.07, -82.3, 70.96, 36.77, 35.17, 56.09, -6.44, 27.78, 11.68, 4.24, -52.02, 10.29, -5.6, -27.45, 25.36, -27.93, -26.09, 20.37, -35.48, -9.33, -3.07, -25.41, 48.74, -6.73, 15.69, -19.61, 9.72, -4.45, -5.23, -10.95, 23.82, -16.65, 29.41, 20.06, 24.96, 4.4, -1.47, -1.71, 16.27, 0.77, -0.69, 61.33, 3.11, 12.46, -1.05, 29.66, 20.95, -3.83, -23.4, 57.41, -65.22, 63.43, -26.72, 7.82, -8.45, 16.04, 11.92, -44.75, 55.66, 63.56, 3.26, -40.56, 0.45, 16.99, 48.41, -21.51, -24.28, -4.3, -56.84, -11.39, 9.51, -14.62, 49.96, -43.34, -8.59, 20.91, 57.32, 3.67, -42.87, -43.62, 34.85, 8.34, -3.54, -39.82, -7.34, 23.38, -16.34, -6.73, -21.87, 19.61, 11.55, 15.91, -48.93, 31.86, -8.75, 46.49, -5.04, 2.24, -6.18, -21.21, 49.18, -54.3, -34.72, 44.72, 13.58, -12.75, 36.43, 29.56, 6.78, -70.78, 44.47, 26.86, 17.68, -2.05, -7.67, -29.99, 27.73, 26.68, -20.88, 12.86, -62.41, 23.44, 62.62, 27.33, 9.12, -16.36, -1.66, 52.32, -32.5, 19.53, -32.0, 18.27, 23.48, 20.58, 20.05, 26.83, -22.13, -15.65, -22.41, -49.49, 12.65, -38.32, -22.71, -1.63, 32.26, -1.67, -2.8, 40.29, 0.89, -4.96, -7.99, 3.0, 20.2, 15.93, -35.72, -7.25, -9.19, -13.33, -5.19, -3.7, -44.57, -34.7, 7.94, -24.55, -28.5, 18.73, -16.98, 42.03, 15.57, -27.86, -35.67, 2.32, 16.27, -11.98, -6.84, 33.88, -74.53, 11.31, -2.14, 18.06, 13.8, 22.36, -49.13, -53.2, -0.76, 2.37, 38.2, 14.43, -0.52, -35.23, 29.99, -28.8, -17.6, 39.26, 3.11, 8.42, 3.6, -3.78, 36.97, 17.4, 21.19, 65.18, 34.14, -3.76, 13.88, -21.05, -26.83, 12.49, 25.01, 29.79, 9.57, -7.19, -39.02, 40.2, -37.59, 16.51, 0.26, 1.5, -17.31, 10.86, -42.04, -1.37, -45.82, -33.57, -63.95, 30.73, 14.7, -14.9, 17.84, 7.75, 18.16, -20.05, -8.21, 6.13, 21.23, 27.56, -28.25, -30.36, 11.0, 66.84, -14.88, 9.16, -43.53, 4.4, 49.71, 29.39, -11.07, 13.8, 11.53, -24.85, 12.83, 15.05, 41.62, -44.83, -9.97, 14.15, -36.99, 10.71, -4.1, -42.0, -7.7, 3.32, 22.93, 5.91, 7.12, 5.57, -33.11, -24.81, 26.52, 31.27, -18.34, -11.11, 3.73, 47.62, -11.93, 1.37, 6.25, 10.25, -7.78, -23.85, -4.08, 58.23, 7.45, 4.21, 29.36, 60.55, -39.44, 14.07, 27.23, 30.32, -12.97, 1.45, 15.89, 15.77, -30.87, -9.49, -26.19, -8.24, 4.28, 4.92, -2.91, -32.19, 20.29, -9.13, 3.27, -31.37, 34.51, 31.42, -13.88, 1.9, -35.31, 2.64, -11.2, -100.0, 5.04, 57.7, -43.23, 0.38, 15.92, -62.88, 0.95, 22.9, 0.07, -8.79, -22.09, 4.81, -12.19, 8.36, 13.39, -2.9, -18.72, 4.07, -35.12, -5.41, 6.26, -3.76, -47.54, -43.32, 51.35, 23.38, -12.92, -5.14, 16.3, -21.77, 37.86, 26.23, 29.91, -10.21, -27.32, 10.31, -12.49, 25.01, -9.89, -15.21, 21.51, -37.32, -62.14, 13.34, 26.2, 36.22, -31.22, 2.77, -16.31, -20.86, -11.86, -24.61, -3.71, 6.67, 31.44, 42.61, -18.29, -11.67, 37.0, 52.79, 63.2, 14.28, -7.11, -8.7, -0.2, -35.43, 12.46, -33.33, -7.54, -21.87, -53.3, -44.05, -30.48, 9.32, -13.28, 18.46, -47.19, 42.46, 4.82, 0.9, -49.4, -9.89, -7.59, -17.77, 1.09, -25.92, -21.08, 5.93, -29.59, 42.77, 47.69, 3.27, -35.86, 18.44, 0.24, -53.14, 14.02, 37.11, 75.39, 14.06, 14.72, -26.91, -46.01, -20.08, -25.37, -41.81, 13.29, -27.25, -9.8, 3.26, -18.63, -28.17, 24.04, -20.79, 53.77, 26.79, 19.72, 46.97, -5.78, 8.72, 0.09, -18.2, -11.14, 8.44, -25.65, -35.05, -12.89, -24.64, -17.57, 19.34, -9.88, -1.79, 6.2, 30.77, 39.21, -60.25, -13.8, 20.15, 20.31, 0.94, -10.13, 2.2, 11.58, 9.48, 19.6, 4.4, 50.93, 6.88, 59.97, -11.01, 18.78, 10.76, 7.51, 4.42, -2.78, -1.1, 2.25, 0.14, -38.51, -21.53, 12.0, -38.42, -1.21, -8.96, -10.33, 29.88, 32.8, 18.7, 9.91, 8.8, -76.96, -10.98, 44.35, 6.17, -21.52, -37.67, 3.91, 17.39, -16.52, -20.21, 21.48, -17.01, 18.63, 66.55, -16.45, -5.21, -14.2, 26.21, -60.21, -25.78, 8.28, -31.86, -49.48, 37.94, -17.53, -79.12, -40.61, 37.5, -25.76, 28.78, 3.0, 19.43, -53.79, -2.66, 11.27, -13.81, 23.84, 18.75, 13.23, -4.54, 25.6, -21.11, -4.43, -61.45, -22.03, -17.31, -15.78, -45.46, -4.09, 21.53, 62.81, 21.21, -29.33, 26.73, 32.09, 19.88, 25.17, -28.27, 19.52, 13.4, -11.62, 3.2, -24.63, 2.06, -25.52, -65.66, 36.88, -1.34, -23.04, 32.09, 3.99, -22.01, 33.36, -32.58, -48.51, -7.61, 35.65, 4.58, -16.8, -25.17, 14.6, -7.81, 8.52, -25.75, -5.74, 26.16, 29.35, -28.7, 24.21, 74.54, -9.09, 47.52, -47.08, -39.26, 43.73, -26.08, 63.97, -55.2, 36.36, -17.2, -35.73, 34.08, 5.0, 7.21, 14.46, 66.79, 40.7, 39.51, -12.39, -2.97, 39.69, -54.79, 6.69, 0.43, 22.33, -32.25, 19.17, 20.94, -56.29, -8.0, -32.23, 48.72, -5.14, -63.13, -17.92, -29.48, 2.99, -52.16, 56.63, -15.59, 36.49, -20.45, -16.88, 36.7, -47.15, -11.43, -7.81, 27.77, -11.54, 65.26, 9.63, 17.83, -20.24, 9.86, 0.83, -14.57, -12.72, -23.3, -10.01, -22.02, -22.17, 0.06, -29.66, -18.72, 21.34, 22.63, 47.07, 32.8, -32.61, 16.15, -58.07, 35.26, 10.69, 11.37, -49.52, -23.01, 2.81, 28.88, -19.96, 19.7, -12.03, -18.11, -15.57, 4.98, -21.07, -3.64, -36.39, -55.73, 57.56, -44.29, -15.05, -39.22, 14.13, -54.04, 17.36, -24.99, 33.42, -7.23, -23.78, 36.3, 57.38, 3.3, -4.19, 23.53, -52.48, -26.57, -1.45, -11.61, 0.25, -8.61, 23.88, -23.36, 39.1, 19.17, -19.74, -10.94, 23.92, -4.07, 29.3, 23.18, -35.66, 18.46, -39.54, -25.34, -21.28, -10.73, 17.44, 18.32, -23.87, 3.27, -0.6, -40.66, -0.38, -13.42, -10.6, -13.43, -8.23, -17.18, 13.75, -35.63, 18.15, 19.24, -25.57, -20.77, 1.41, -26.38, -13.26, -12.13, 54.72, -9.09, 7.58, 38.94, 12.76, 57.78, 7.42, 40.66, 1.78, -15.05, 39.26, 20.39, 17.29, -8.93, -35.18, -13.82, 13.86, -30.12, 23.08, -23.03, 70.38, 100.0, -21.25, 2.08, 26.94, 23.3, 49.5, 34.56, 1.04, 7.7, 10.93, -36.01, 41.92, 17.64, -40.38, 2.12, -4.27, 14.28, 29.26, -10.22, 4.17, 9.99, 26.97, 6.65, -65.58, 89.68, 33.73, 7.65, 17.03, -45.83, 28.74, 33.4, 24.5, 42.57, 5.01, -49.21, -8.03, -13.46, -14.95, -3.17, -22.05, -34.83, -32.79, 22.93, -2.96, -4.49, -6.71, -37.4, 20.2, 7.29, -9.43, -1.53, 17.09, -32.36, -22.61, -40.32, -36.19, 10.2, 0.56, -34.63, 4.96, -16.12, 29.56, 75.58, -36.45, 6.38, -4.76, -26.64, -33.0, 14.45, -2.89, 3.75, 11.27, 6.99, -55.78, -31.65, -31.67, -24.33, -67.78, 7.39, 28.24, -41.15, 11.89, -39.43, 41.48, 20.92, -44.26, -0.83, 5.09, 6.52, 26.8, 2.32, -22.25, -29.62, -21.96, 16.22, 21.46, -21.02, -11.34, -3.51, -24.92, -19.5, 38.19, 1.65, -47.21, 14.63, -5.64, 35.3, 33.18, -42.26, -66.83, 7.26, 17.65, -32.9, -10.46, -20.12, -83.84, -21.89, 28.2, -7.52, -55.84, 34.3, 30.95, 58.41, -13.97, -0.24, -7.14, 12.05, -20.39, -9.03, 8.09, 24.75, -6.41, 6.07, -7.17, 36.28, 33.6, -13.83, 40.31, 3.21, -39.52, 18.19, -20.85, -16.65, 28.55, -5.03, 38.6, 34.58, 10.59, -17.81, 55.68, 54.18, 18.82, 51.76, -31.86, -15.26, 54.08, 16.86, 34.08, -3.62, 29.48, -17.36, -41.21, -33.21, 80.47, 13.64, -21.98, -36.72, 11.72, -10.68, 2.79, -13.98, -35.93, -44.56, -2.31, 41.57, -19.15, -77.42, 73.67, 9.81, 4.97, -44.14, 30.56, 7.66, -23.15, 7.37, -11.37, 14.58, -11.7, -31.54, -38.13, -25.83, -30.76, -16.96, -27.29, -50.67, 5.76, 16.91, -20.88, -21.55, -3.24, -15.8, 34.49, -27.69, 46.61, -0.92, 12.08, -19.29, -1.83, 24.66, -7.48, 46.79, 24.61, -14.73, 49.3, -6.68, 7.58, 13.06, 37.62, -15.54, -45.87, -6.45, -9.59, -10.86, -78.44, -12.58, 10.15, 14.93, -24.52, 3.24, 4.56, -3.15, -47.31, 6.92, -4.45, -4.18, 27.98, -14.32, -10.05, -17.57, -11.36, -48.56, 26.96, 35.07, 42.41, -6.23, -36.89, 3.7, -30.43, 6.73, 17.99, -43.7, 33.34, 16.45, -32.84, 17.0, 6.43, 57.56, -18.89, -12.75, 19.27, -3.85, -8.39, 22.91, 36.94, -7.78, -59.94, -27.81, 10.54],
			data: dailyData,
			backgroundColor: themeColor,
			borderColor: themeColor,
			borderWidth: 1,
			pointRadius: 0,
			}
		]
		};

		if (chart5Container) {
			chart5Container.innerHTML = '<canvas id="chart5" className="w-100" height="390"></canvas>';
			chart5 = new ChartJS(document.getElementById('chart5').getContext('2d'), {
				type: 'line',
				data: data,
				options: {
					maintainAspectRatio: false,
					scales: {
						x: {
						  stacked: true,
						  grid: {
							display: false  // ⛔ remove linhas verticais
						  }
						},
						y: {
						  stacked: true,
						  grid: {
							display: false  // ⛔ remove linhas verticais
						  }
						}
					  }
				}
			});
		}
		
	};
  
	useEffect(() => {
			context.setAppHeaderNone(false);
			context.setAppSidebarNone(true);
			context.setAppContentFullHeight(false);
			//context.setAppContentClass('p-0');
			//setChartOptions(getChartOptions());
			getChartJsDefaultOptions();
			
			/*
			fetch('/assets/data/dashboard/stats.json').then(res => res.json()).then((result) => { setStatsData(result); });
			fetch('/assets/data/dashboard/traffic.json').then(res => res.json()).then((result) => { setTrafficData(result); });
			fetch('/assets/data/dashboard/security.json').then(res => res.json()).then((result) => { setSecurityData(result); });
			fetch('/assets/data/dashboard/threat.json').then(res => res.json()).then((result) => { setThreatData(result); });
			fetch('/assets/data/dashboard/business.json').then(res => res.json()).then((result) => { setBusinessData(result); });
			fetch('/assets/data/dashboard/sales.json').then(res => res.json()).then((result) => { setSalesData(result); });
			fetch('/assets/data/dashboard/operational.json').then(res => res.json()).then((result) => { setOperationalData(result); });
			fetch('/assets/data/dashboard/social.json').then(res => res.json()).then((result) => { setSocialData(result); });
			fetch('/assets/data/dashboard/products.json').then(res => res.json()).then((result) => { setProductsData(result); });
			fetch('/assets/data/dashboard/marketing.json').then(res => res.json()).then((result) => { setMarketingData(result); });
			*/

			//MOCK
			//localStorage.setItem("bs_token",'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6MSwiZW1haWwiOiJrc212YWxlbnRlQGdtYWlsLmNvbSIsImV4cCI6MTc0NzM0NDEwOH0.7V1DheuuEZqtkyCAE_pxCNrsrJxHZ45fpabewCtnlDw');

			const query = new URLSearchParams(location.search);
  			const token = query.get('t');

			//alert('token: '+token)

			if (token != undefined) {

				fetch(externalAddress+'/api/biblioteca/sso/'+token).then(res => res.json()).then((result) => { 
					localStorage.setItem("bs_token", result.t);
					//loadSetup();
					checkTelefone();

				});

			} else {
				//loadSetup();
				checkTelefone();
			}
			
			renderMap();
			//renderChart();
			
			
			document.addEventListener('theme-reload', () => {
				renderMap();
				//renderChart();
				//setChartOptions(getChartOptions());
				//renderChart();
			});
			
			return function cleanUp() {
				const mapElm = document.querySelectorAll('.jvm-tooltip');
			
				if (mapElm) {
					for (let i = 0; i < mapElm.length; i++) {
						mapElm[i].remove();
					}
				}
			}
			
			// eslint-disable-next-line
	}, []);

	function checkTelefone() {

		fetch(externalAddress+'/api/biblioteca/checkusuario', {
				headers: {
				'HTTP-AUTHORIZATION': localStorage.getItem("bs_token")
			}}).then(res => {
				if (res.status == 401) {
					localStorage.clear();
					//window.location.href = 'https://botspot.com.br/login?to=/setup/'+id;
					window.location.href = botspotAddress+'/login?to=/setup/'+id;
				}
				if (res.status == 403) {
					localStorage.clear();
					//window.location.href = 'https://botspot.com.br/login?to=/setup/'+id;
					window.location.href = botspotAddress+'/login?to=/setup/'+id;
				}
				return res.json()
			})
			.then((result) => { 
				
				if (!result.cadastro)
					navigate('/telefone?to=/setup/'+id);
				else
					loadSetup();

			});

	}

	function loadSetup() {

		fetch(externalAddress+'/api/biblioteca/setup/'+id, {
				headers: {
				'HTTP-AUTHORIZATION': localStorage.getItem("bs_token")
			}}).then(res => {
				if (res.status == 401) {
					localStorage.clear();
					//window.location.href = 'https://botspot.com.br/login?to=/setup/'+id;
					window.location.href = botspotAddress+'/login?to=/setup/'+id;
				}
				if (res.status == 403) {
					localStorage.clear();
					//window.location.href = 'https://botspot.com.br/login?to=/setup/'+id;
					window.location.href = botspotAddress+'/login?to=/setup/'+id;
				}
				return res.json()
			})
			.then((result) => { 
				//console.log('result')
				//console.log(result)
				setData(result);
				setEstrategia(result.estrategia);
				setMetricas(result.metricas);
				loadBSS(result.metricas.botspotScore)
				//getSeriesChart(result.metricas.matrizMensal);

				var lineChart = result.lineChart
				if (result.floatingLineChart.length > 0)
					lineChart = result.floatingLineChart

				setEquityChart(lineChart);
				setBarChart(result.barChart);
				requestAnimationFrame(() => {
					renderChart(lineChart, result.barChart, result.dailyChart);
					getSeriesChart(result.metricas.matrizMensal);
					setTotalMeses(lineChart.length)
				});
			});

	}

	function loadBSS(bss) {

		if (bss <= 3.40) {
            setBotspotScore('Ruim')
        } else if (bss >= 3.41 && bss <= 7) {
            setBotspotScore('Regular')
        } else if (bss >= 7.01 && bss <= 10) {
            setBotspotScore('Bom')
        } else if (bss >= 10.01 && bss <= 14) {
            setBotspotScore('Ótimo')
        } else if (bss >= 14.01) {
            setBotspotScore('Excelente')
        }

	}

	var themeColor = (getComputedStyle(document.body).getPropertyValue('--bs-theme')).trim();

	const optionsChart = {
		chart: {
		  type: 'heatmap',
		  height: 680
		},
		tooltip: {
			enabled: false  // ⛔ desativa o tooltip ao passar o mouse
		},
		legend: {
			show: false  // ⛔ oculta a legenda
		  },
		xaxis: {
			labels: {
			  style: {
				colors: '#FFF', // 🔸 cor dos labels do eixo X
				fontSize: '12px',
				fontWeight: 400
			  }
			}
		  },
		  yaxis: {
			labels: {
			  style: {
				colors: '#FFF', // 🔸 cor dos labels do eixo Y
				fontSize: '12px',
				fontWeight: 400
			  }
			}
		  },
		  
		colors: ['#FFF'],
		//shadeIntensity: 0.8,
		plotOptions: {
			heatmap: {
				enableShades: false,
				shadeIntensity: 1,
				//distributed: true,
				//reverseNegativeShade: true,
				radius: 0,
				useFillColorAsStroke: false,
				reverseNegativeShade: false,
				colorScale: {
				  
				  ranges: [
					{
					  from: -5000,
					  to: 0,
					  name: 'Baixa',
					  color: '#EE7935',
					},
				
					{
					  from: 0,
					  to: 100000,
					  name: 'Alta',
					  color: '#61A4F1'
					}
				  ],
				}
			  }
		},
		dataLabels: { enabled: true, 
		  style: {
			colors: ['#000']  
		  },
		  formatter: function (val) {
				return val
				.toFixed(2)                     // "2527.89"
				.replace('.', ',')             // "2527,89"
				.replace(/\B(?=(\d{3})+(?!\d))/g, '.'); // "2.527,89"
		  },
			
		 },

	};

	/*
	const seriesChart = Array.from({ length: 10 }, (_, i) => ({
		name: `Linha ${i + 1}`,
		data: Array.from({ length: 10 }, (_, j) => ({
		  x: `Coluna ${j + 1}`,
		  y: Math.floor(Math.random() * 201) - 100
		}))
	  }));
	*/

	const anos = [2021, 2022, 2023, 2024, 2025];
	const meses = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

	/*
	function seriesChart() {
		return anos.map(ano => {
			const retornosMensais = Array.from({ length: 12 }, () =>
			+(Math.random() * 10 - 5).toFixed(2) // entre -5.00% e +5.00%
			);
			const total = +(retornosMensais.reduce((a, b) => a + b, 0)).toFixed(2);

			return {
			name: ano.toString(),
			data: [...retornosMensais.map((valor, i) => ({
				x: meses[i],
				y: valor
			})), {
				x: 'Total',
				y: total
			}]
			};
		});
	}
	*/

	//const seriesChart = [{'x': 'Jan' , 'y': 2021}, {'x': 'Jan' , 'y': 2021}];

	/*
	const seriesChart = Array.from({ length: 5 }, (_, i) => ({
		name: `Linha ${i + 1}`,
		data: Array.from({ length: 13 }, (_, j) => ({
		  x: `Coluna ${j + 1}`,
		  y: Math.floor(Math.random() * 2000) - 1000
		}))
	  }));
	*/

	//console.log('seriesChart')
	//console.log(seriesChart)

	function getSeriesChart(matriz) {

		console.log('matriz')
		console.log(matriz)

		if (matriz == undefined) {
			var heatmap = Array.from({ length: 5 }, (_, i) => ({
				name: `Linha ${i + 1}`,
				data: Array.from({ length: 13 }, (_, j) => ({
				x: `Coluna ${j + 1}`,
				y: Math.floor(Math.random() * 2000) - 1000
				}))
			}));
			setSeriesChart(heatmap);
			return;
		}

		var heatmap = matriz.map(item => ({
			name: item.name.toString(), 
			data: item.data
		}));

		setSeriesChart(heatmap)

	}

	const voltar = () => {
		navigate('/setups');
	};

	const download = () => {

		/*

		fetch(externalAddress+'/api/biblioteca/download/'+id, {
				headers: {
				'HTTP-AUTHORIZATION': localStorage.getItem("bs_token")
			}}).then(res => {
				if (res.status == 401) {
					localStorage.clear();
					//window.location.href = 'https://botspot.com.br/login?to=/setup/'+id;
					window.location.href = 'http://localhost:3000/login?to=/setup/'+id;
				}
				if (res.status == 403) {
					localStorage.clear();
					//window.location.href = 'https://botspot.com.br/login?to=/setup/'+id;
					window.location.href = 'http://localhost:3000/login?to=/setup/'+id;
				}
				return res.json()
			})
			.then((result) => { 
				
			});

		*/

		fetch(externalAddress+'/api/biblioteca/download/'+id, {
				cache: 'no-store',
				headers: {
				'HTTP-AUTHORIZATION': localStorage.getItem("bs_token")
			}}) 
		.then(response => {
			console.log(response)
			if (!response.ok) {
				document.getElementById('closemodal')?.click();

				if (response.status == 401)
					navigate('/planos');
				else
					navigate('/planos?setup=black');
				return;
			}

			const contentDisposition = response.headers.get('Content-Disposition');
    		let filename = 'arquivo.set';

			if (contentDisposition && contentDisposition.includes('filename=')) {

				const matchEncoded = contentDisposition.match(/filename\*=UTF-8''([^;\n]+)/);
				if (matchEncoded) {
					filename = decodeURIComponent(matchEncoded[1]);
				} else {

					const matchNormal = contentDisposition.match(/filename="([^"]+)"/);
					if (matchNormal) {
						filename = matchNormal[1];
					}
				}
			}

			return response.blob().then(blob => ({ blob, filename }));
		})
		.then(({ blob, filename }) => {

			const url = window.URL.createObjectURL(blob);
			const link = document.createElement('a');
			link.href = url;

			link.download = filename;
			document.body.appendChild(link);
			link.click();

			// Limpeza
			link.remove();
			window.URL.revokeObjectURL(url);
			document.getElementById('closemodal')?.click();
		})
		.catch(err => {
			console.error('Erro no download:', err);
		});


	};
	
	return (
		
		<div className="row g-2">

			<div className="pos-header">
				
				<button type="button" className="btn btn-outline-theme" onClick={voltar}>Voltar</button>
				<div className="nav" style={{float: 'right'}}>
					
					<div className="">
						<Link to="#/" style={{paddingRight: '0px'}} data-bs-toggle="tooltip" data-bs-placement="bottom" className="nav-link active">
							<div className="nav-icon">
							
							<button type="button" className="btn btn-theme" data-bs-toggle="modal" data-bs-target="#modalLg">DOWNLOAD SETUP</button>
							</div>
						</Link>
					</div>
				</div>
			</div>

			<div className="modal fade" id="modalLg">
				<div className="modal-dialog modal-lg">
					<div className="modal-content">
						<div className="modal-header">
							<h5 className="modal-title">TERMOS DE USO</h5>
							<button type="button" id="closemodal" className="btn-close" data-bs-dismiss="modal"></button>
						</div>
						<div className="modal-body">
							<div>
							Os setups disponibilizados nesta Biblioteca de Setups são fruto de processos automatizados de data mining realizados por meio do robô SDK. Eles são entregues como modelos operacionais brutos, com o objetivo de fornecer ideias de estratégias que o usuário poderá analisar, testar e adaptar conforme seus próprios critérios.<br/><br/>

							Esses setups não passaram por validação estatística nem testes de robustez, como backtests detalhados, análises out-of-sample ou walk forward analysis. Cabe exclusivamente ao usuário realizar todas as etapas de validação e avaliação de risco antes de utilizar qualquer estratégia em conta real.<br/><br/>

							Ao fazer o download e utilizar qualquer setup disponibilizado nesta plataforma, o usuário declara estar ciente de que:<br/>

							- A utilização de robôs e estratégias automatizadas envolve risco de perdas financeiras;<br/>

							- O produto é voltado à renda variável, e não há garantias de retorno;<br/>

							- A decisão de ativar qualquer robô ou estratégia em conta real é inteiramente de sua responsabilidade;<br/><br/>

							A Data N' Quant não se responsabiliza por quaisquer prejuízos diretos ou indiretos causados por uso inadequado, falta de validação ou execução de estratégias derivadas desta biblioteca.<br/><br/>

							Recomendamos fortemente que todos os setups sejam validados e adaptados ao seu perfil de risco e objetivos operacionais antes de qualquer operação com capital real.<br/><br/>

							Ao fazer o download, você concorda com estes termos de uso.<br/>
							<br></br>
							</div>
							<button type="button" className="btn btn-theme mt-3" onClick={download}>DOWNLOAD</button>
						</div>
					</div>
				</div>
			</div>



			<div className="col-xl-4 col-lg-6">
			<Card className="h-100">
				<CardHeader className="with-btn">
				{estrategia.nome}
				<CardHeaderBtn />
				</CardHeader>

				<CardBody>

				<div className="row g-3">
					<div className="col-4">
						<div className="d-flex align-items-center">
						<div className="fs-32px text-theme d-flex w-40px">
							<Icon icon="material-symbols-light:touch-app-outline" />
						</div>
						<div className="flex-1">
							<div className="fs-10px fw-semibold text-white text-opacity-50 mb-1">
							Classe de Ativo
							</div>
							<div className="h6 mb-0 fw-base">{estrategia.mercado}</div>
						</div>
						</div>
					</div>
					<div className="col-4">
						<div className="d-flex align-items-center">
						<div className="fs-32px text-theme d-flex w-40px">
							<Icon icon="material-symbols-light:group-outline" />
						</div>
						<div className="flex-1">
							<div className="fs-10px fw-semibold text-white text-opacity-50 mb-1">
							Ativo
							</div>
							<div className="h6 mb-0 fw-base">{estrategia.ativo}</div>
						</div>
						</div>
					</div>
					<div className="col-4">
						<div className="d-flex align-items-center">
						<div className="fs-32px text-theme d-flex w-40px">
							
							<Icon icon="material-symbols-light:bar-chart-4-bars" />
						</div>
						<div className="flex-1">
							<div className="fs-10px fw-semibold text-white text-opacity-50 mb-1">
							Timeframe
							</div>
							<div className="h6 mb-0 fw-base">{estrategia.timeframe}</div>
						</div>
						</div>
					</div>

					<hr className="invisible m-0" />
					<hr />

					<div className="col-4">
						<div className="d-flex align-items-center">
						<div className="fs-32px text-theme d-flex w-40px">
							<Icon icon="material-symbols-light:store-outline" />
						</div>
						<div className="flex-1">
							<div className="fs-10px fw-semibold text-white text-opacity-50 mb-1">
							Prazo
							</div>
							<div className="h6 mb-0 fw-base">{estrategia.tipo}</div>
						</div>
						</div>
					</div>

					<div className="col-4">
						<div className="d-flex align-items-center">
						<div className="fs-32px text-theme d-flex w-40px">
							<Icon icon="material-symbols-light:approval-delegation-outline" />
						</div>
						<div className="flex-1">
							<div className="fs-10px fw-semibold text-white text-opacity-50 mb-1">
							Sentido
							</div>
							<div className="h6 mb-0 fw-base">{estrategia.sentido}</div>
						</div>
						</div>
					</div>

					<div className="col-4">
						<div className="d-flex align-items-center">
						<div className="fs-32px text-theme d-flex w-40px">
							<Icon icon="material-symbols-light:app-badging-outline" />
						</div>
						<div className="flex-1">
							<div className="fs-10px fw-semibold text-white text-opacity-50 mb-1">
							Lado
							</div>
							<div className="h6 mb-0 fw-base">{estrategia.lado}</div>
						</div>
						</div>
					</div>
					
				</div>
				</CardBody>
			</Card>
			</div>

			<div className="col-xl-4 col-lg-6">
				<Card>
					<CardHeader className="with-btn">
					LUCRO ACUMULADO
					<CardHeaderBtn />
					</CardHeader>
					<CardBody style={{minHeight: '116px'}}>
						<div className="mb-2 small text-white fw-semibold d-flex align-items-center">
						
						</div>
						<div className="row mb-1">
						<div className="col-lg-12 position-relative">
							<h1 className="mb-1 d-flex align-items-center text-theme">
								{metricas.totalLucro}
							</h1>
							<div className="small"><span className="badge bg-theme bg-opacity-15 text-theme py-2 me-1 fs-9px">{metricas.fatorLucro}</span> Fator de Lucro</div>
							<i className="fa fa-money-bill-alt display-3 lh-1 text-body text-opacity-20 me-3 position-absolute end-0 top-0"></i>
						</div>
						</div>
						<div className="mt-3 fs-9px fw-semibold text-body text-opacity-50">
						<div>Média Mensal:</div>
						<div className="text-body text-opacity-75">{metricas.mediaMensal}</div>
						</div>
					</CardBody>
				</Card>
			</div>

			<div className="col-xl-4 col-lg-6">
				<Card className="h-100">
					<CardHeader className="with-btn">
						PERFORMANCE DIÁRIA
						<CardHeaderBtn />
					</CardHeader>
	
					<CardBody className="text-white fs-10px fw-semibold">
						<div className="d-flex align-items-center mb-1" >
							<span
								className={"bg-theme text-black w-15px h-15px d-flex align-items-center justify-content-center"}
							>
								1
							</span>
							<span className="flex-1 ps-2">TAXA DE ACERTO</span>
							<span className="w-110px">
								<div className="progress h-3px bg-black mt-1px">
									<div
										className={ (metricas.diasPositivos / metricas.totalDias * 100) > 50 ? "bg-theme bg-opacity-75 progress-bar" : "bg-theme bg-opacity-50 progress-bar"}
										style={{ width: (metricas.diasPositivos / metricas.totalDias * 100) }}
									></div>
								</div>
							</span>
							<span className="w-50px text-end">{metricas.taxaAcerto}</span>
						</div>
						<div className="d-flex align-items-center mb-1" >
							<span
								className={"bg-theme bg-opacity-75 text-black text-black w-15px h-15px d-flex align-items-center justify-content-center"}
							>
								2
							</span>
							<span className="flex-1 ps-2">TOTAL DE DIAS</span>
							<span className="w-110px">
								<div className="progress h-3px bg-black mt-1px">
									<div
										className={"bg-theme progress-bar"}
										style={{ width: "100%" }}
									></div>
								</div>
							</span>
							
							<span className="w-50px text-end">{metricas.totalDias}</span>
						</div>
						<div className="d-flex align-items-center mb-1" >
							<span
								className={"bg-theme bg-opacity-50 text-black text-black w-15px h-15px d-flex align-items-center justify-content-center"}
							>
								3
							</span>
							<span className="flex-1 ps-2">DIAS POSITIVOS</span>
							<span className="w-110px">
								<div className="progress h-3px bg-black mt-1px">
									<div
										className={ (metricas.diasPositivos / metricas.totalDias * 100) > 50 ? "bg-theme bg-opacity-75 progress-bar" : "bg-theme bg-opacity-50 progress-bar"}
										style={{ width: (metricas.diasPositivos / metricas.totalDias * 100) }}
									></div>
								</div>
							</span>
							<span className="w-50px text-end">{metricas.diasPositivos}</span>
						</div>
						<div className="d-flex align-items-center mb-1" >
							<span
								className={"bg-theme bg-opacity-25 text-black text-black text-black w-15px h-15px d-flex align-items-center justify-content-center"}
							>
								4
							</span>
							<span className="flex-1 ps-2">DIAS NEGATIVOS</span>
							<span className="w-110px">
								<div className="progress h-3px bg-black mt-1px">
									<div
										className={ (metricas.diasNegativos / metricas.totalDias * 100) > 50 ? "bg-theme bg-opacity-75 progress-bar" : "bg-theme bg-opacity-50 progress-bar"}
										style={{ width: (metricas.diasNegativos / metricas.totalDias * 100) }}
									></div>
								</div>
							</span>
							<span className="w-50px text-end">{metricas.diasNegativos}</span>
						</div>
						
					</CardBody>
				</Card>
			</div>

			<div className="col-xl-4 col-lg-6">
				<Card className="h-100">
					<CardHeader className="with-btn">
						RISCO RETORNO
						<CardHeaderBtn />
					</CardHeader>
					<CardBody>
						<div className="row">
								<div className="col-4">
									<div className="fw-semibold text-white text-opacity-50 fs-10px mb-2">PAYOFF</div>
									<div className="h4 text-theme mb-2">{metricas.payoff}</div>
									
								</div>
								<div className="col-4">
									<div className="fw-semibold text-white text-opacity-50 fs-10px mb-2">MÉDIA DIAS POSITIVOS</div>
									<div className="h4 text-theme mb-2">{metricas.mediaDiasPositivos}</div>
									
								</div>
								<div className="col-4">
									<div className="fw-semibold text-white text-opacity-50 fs-10px mb-2">MÉDIA DIAS NEGATIVOS</div>
									<div className="h4 text-theme mb-2">{metricas.mediaDiasNegativos}</div>
									
								</div>
						</div>
					
					</CardBody>
				</Card>
			</div>

			<div className="col-xl-4 col-lg-6">
				<Card>
					<CardHeader className="with-btn">
					RISCO
					<CardHeaderBtn />
					</CardHeader>
					<CardBody>
					
						<div className="row mb-1">
							<div className="col-lg-6 position-relative">
								<div className="fw-semibold text-white text-opacity-50 fs-10px mb-2">DRAWDOWN MÁXIMO</div>
								<h1 className="h4 text-theme mb-2">
									{data.floating?.floatingDD}
								</h1>
								<div className="fs-10px">
									<div>
										<span className="text-white fw-semibold">{data.floating?.inicioFloatingDD} - {data.floating?.dataFimDD}</span> 
									</div>
								</div>
							</div>
							<div className="col-lg-6 position-relative">
								<div className="fw-semibold text-white text-opacity-50 fs-10px mb-2">FATOR DE RECUPERAÇÃO</div>
								<h1 className="h4 text-theme mb-2">
									{metricas.sharpe}
								</h1>
							</div>
						</div>
						
					</CardBody>
				</Card>
			</div>

			<div className="col-xl-4 col-lg-6">
				<Card className="h-100">
					<CardHeader className="with-btn">
						RISCO RETORNO
						<CardHeaderBtn />
					</CardHeader>
					<CardBody>
						<div className="row">
							<div className="col-6">
								<div className="fw-semibold text-white text-opacity-50 fs-10px mb-2">MAIOR PREJUÍZO DIÁRIO</div>
								<div className="h4 text-theme mb-2">{metricas.maiorLossDiario}</div>
								<div className="fs-10px">
									<div>
										<span className="text-white fw-semibold">{metricas.dataMaiorLoss}</span> 
									</div>
								</div>
							</div>
							<div className="col-6">
								<div className="fw-semibold text-white text-opacity-50 fs-10px mb-2">MAIOR LUCRO DIÁRIO</div>
								<div className="h4 text-theme mb-2">{metricas.maiorGainDiario}</div>
								<div className="fs-10px">
									<div>
										<span className="text-white fw-semibold">{metricas.dataMaiorGain}</span> 
									</div>
								</div>
							</div>
						</div>
					</CardBody>
				</Card>
			</div>

			<div className="col-xl-12">
				<div className="row g-2">
					<div className="col-xl-2 col-lg-4 col-6">
						<Card className="h-100">
							<CardHeader>ROBÔ - VERSÃO</CardHeader>
							<CardBody>
								<div className="">{estrategia.robo}</div>
							</CardBody>
						</Card>
					</div>

					<div className="col-xl-2 col-lg-4 col-6">
						<Card className="h-100">
							<CardHeader>MEDIANA DE LUCRO</CardHeader>
							<CardBody>
								<div className="">{metricas.mediana}</div>
							</CardBody>
						</Card>
					</div>

					<div className="col-xl-2 col-lg-4 col-6">
						<Card className="h-100">
							<CardHeader>PERÍODO DE ESTAGNAÇÃO</CardHeader>
							<CardBody>
								<div className="">{metricas.dataInicioEstagnacao} - {metricas.dataFimEstagnacao}</div>
							</CardBody>
						</Card>
					</div>

					<div className="col-xl-2 col-lg-4 col-6">
						<Card className="h-100">
							<CardHeader>TOTAL DE MESES</CardHeader>
							<CardBody>
								<div className="">{totalMeses}</div>
							</CardBody>
						</Card>
					</div>

					<div className="col-xl-2 col-lg-4 col-6">
						<Card className="h-100">
							<CardHeader>Value at Risk</CardHeader>
							<CardBody>
								<div className="">{metricas.valueAtRisk}</div>
							</CardBody>
						</Card>
					</div>

					<div className="col-xl-2 col-lg-4 col-6">
						<Card className="h-100">
							<CardHeader>BOTSPOT SCORE</CardHeader>
							<CardBody>
								<div className="">
									{botspotScore}
								</div>
							</CardBody>
						</Card>
					</div>
				</div>
			</div>

			<div className="col-xl-8">
				<Card className="h-100">
					<CardHeader className="with-btn">
						CURVA DE CAPITAL
						<CardHeaderBtn />
					</CardHeader>
					
					<CardBody>
						
						<div>
							<div className="chart mb-2" style={{height: '390px'}}>
								<div id="chart-3"></div>
							</div>
						</div>
					</CardBody>
				</Card>
			</div>

			<div className="col-xl-4">
				<Card className="h-100">
					<CardHeader className="with-btn">
						ANO A ANO
						<CardHeaderBtn />
					</CardHeader>
					
					<CardBody>
						
						<div>
							<div className="chart mb-2" style={{height: '390px'}}>
								<div id="chart-4"></div>
							</div>
						</div>
					</CardBody>
				</Card>
			</div>

			<div className="col-xl-12">
				<Card className="h-100">
					<CardHeader className="with-btn">
						RETORNOS DIÁRIOS
						<CardHeaderBtn />
					</CardHeader>
					
					<CardBody>
						
						<div>
							<div className="chart mb-2" style={{height: '390px'}}>
								<div id="chart-5"></div>
							</div>
						</div>
					</CardBody>
				</Card>
			</div>

			<div className="col-xl-12">
				<Card className="h-100">
					<CardHeader className="with-btn">
						RETORNOS MENSAIS
						<CardHeaderBtn />
					</CardHeader>
					
					<CardBody>
						
						<div>
							<div className="chart mb-2" style={{height: '390px'}}>
								<Chart options={optionsChart} series={seriesChart} type="heatmap" height={350} />
							</div>
						</div>
					</CardBody>
				</Card>
			</div>

		</div>
	)
};

export default Backtest;